module services {
    export module applicationcore {
        export class UNSPSCCodeService implements interfaces.applicationcore.IUNSPSCCodeService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            getUNSPSCCodeList(): ng.resource.IResourceClass<interfaces.applicationcore.UNSPSCCodeDisplay> {
                return this.$resource<interfaces.applicationcore.UNSPSCCodeDisplay>(this.ENV.DSP_URL + "UNSPSCCode/GetUNSPSCCodeList", {
                    connectSearch: '@connectSearch',
                    numberRecords: '@numberRecords',
                    pageNumber: '@pageNumber',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates },
                            params: {
                                numberRecords: 25,
                                pageNumber: 1,
                            }
                        }
                    });
            } 
        }
    }
    angular.module("app").service("unspscCodeService", services.applicationcore.UNSPSCCodeService);
}